//<button
//                     className="px-3 py-1 rounded-md text-white"
//                     style={{ backgroundColor: item.buttonColor }}
//                     disabled={!item.isEnabled}
//                   >
//                     {item.buttonName}
//                   </button>

import React, { useState, useEffect } from "react";
import { useToast } from "../../../../Components/Others/ToastServices";
import axiosInstance from "../../../../Services/axiosCommon";
import { NuInput } from "../../../../Components/Utils/Input";
import DeleteIcon from "../../../../Components/Icons/Delete";
import { GetAccess } from "../../../../Components/Utils/roles";


const ApprovalProcess = ({ moduleName }) => {
  const [status, setStatus] = useState("");
  const [buttonName, setButtonName] = useState("");
  const [buttonColor, setButtonColor] = useState("#000000");
  const [approvalList, setApprovalList] = useState([]);
  const [Id, setId] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    fetchApprovalStatuses();
  }, []);

  const fetchApprovalStatuses = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/approval-status/by-module/${moduleName}`
      );
      const data = response.data.data || [];
      setApprovalList(data);
      const ids = data.map(item => item.id);
    setId(ids);
 

    } catch (error) {
      console.error("Error fetching approval statuses:", error);
    } finally {
      setLoading(false);
    }
  };

  const addApprovalStatus = () => {
    if (!status || !buttonName) {
      toast.open({
        type: "error",
        message: "Error",
        description: "Please fill in both Status and Button Name",
      });
      return;
    }

    const newStatus = {
    //   id: ids,
      status,
      isEnabled: true,
      buttonColor,
      buttonName,
      order: approvalList.length + 1,
    };

    setApprovalList((prev) => [...prev, newStatus]);
    setStatus("");
    setButtonName("");
    setButtonColor("#000000");
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setShowDeleteConfirm(true);
  };

  // Actual delete function (only called when OK is clicked)
  const confirmDelete = async () => {
    if (!itemToDelete) return;
    
    try {
      const res = await axiosInstance.delete(`/approval-status/${itemToDelete}`);
      if (res?.data?.status) {
        fetchApprovalStatuses(); // Refresh the list
        toast.open({
          type: "success",
          message: "Success",
          description: res.data?.msg || "Deleted Successfully.",
        });
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data.error || "Network error.",
        });
      }
    } catch (err) {
      toast.open({
        type: "error",
        message: "Error",
        description: err.response?.data?.error || "Delete failed.",
      });
    } finally {
      setShowDeleteConfirm(false);
      setItemToDelete(null);
    }
  };

  // Cancel delete
  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setItemToDelete(null);
  };
  
  const submitApprovalStatuses = async () => {
    if (approvalList.length === 0) {
      toast.open({
        type: "error",
        message: "Error",
        description: "Please add at least one approval status.",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post("/approval-status/multi", {
        module: moduleName,
        all_status: approvalList, 
      });

      if (response.data.status) {
        toast.open({
          type: "success",
          message: "Success",
          description: "Approval statuses submitted successfully!",
        });

        fetchApprovalStatuses(); 
      } else {
        throw new Error("Submission failed");
      }
    } catch (error) {
      toast.open({
        type: "error",
        message: "Error",
        description: "Failed to submit approval statuses.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="p-2 bg-white rounded-lg shadow-lg w-full">
     <h2 className="text-sm font-medium mb-1">
  {moduleName
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")}
</h2>


      <div className="sm:flex">
        <div className="sm:flex gap-4 mb-2">
          <NuInput
            label="Status"
            type="text"
            placeholder="Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          />
          <NuInput
            label="Button Name"
            type="text"
            placeholder="Button Name"
            value={buttonName}
            onChange={(e) => setButtonName(e.target.value)}
          />
          <NuInput
            label="Color"
            type="color"
            value={buttonColor}
            onChange={(e) => setButtonColor(e.target.value)}
          />
        </div>
        {GetAccess('approvalstatus_create')&&

        <button
          onClick={addApprovalStatus}
          className="bg-baseColor-primary text-xs text-white h-8 px-2 py-1 mt-10 rounded-md"
        >
          Add
        </button>}
      </div>

      <div className="mt-2">
        <div className="border rounded-lg overflow-hidden">
          <table className="w-full border-collapse">
            <thead className="bg-baseColor-primary text-white">
              <tr>
                <th className="p-2 text-sm font-medium">S.No</th>
                <th className="p-2 text-sm font-medium">Status</th>
                <th className="p-2 text-sm font-medium">Button Name</th>
                <th className="p-2 text-sm font-medium">Button Color</th>
                {GetAccess('approvalstatus_delete')&&

                <th className="p-2 text-sm font-medium">Action</th>}
              </tr>
            </thead>
            <tbody>
              {approvalList.map((item, index) => (
                <tr key={item.id} className="text-center">
                  <td className="p-1 border text-xs text-[#4F4768]">
                    {index + 1}
                  </td>
                  <td className="p-1 border text-xs text-[#4F4768]">
                    {item.status}
                  </td>
                  <td className="p-1 border text-xs text-[#4F4768]">
                    {item.buttonName}
                  </td>
                  <td className="p-1 border text-xs text-[#4F4768]">
                    {/* <span
                      className="w-6 h-6 inline-block rounded"
                      style={{ backgroundColor: item.buttonColor }}
                    ></span> */}
                    <button
                                         className="px-3 py-1 rounded-md text-white"
                                         style={{ backgroundColor: item.buttonColor }}
                                         disabled={!item.isEnabled}
                                       >
                                         {item.buttonName}
                                       </button>
                    
                  </td>
                  {GetAccess('approvalstatus_delete')&&
                  <td className="p-1 border text-xs text-[#4F4768]">
                    <div
                      className="flex justify-center cursor-pointer"
                      onClick={() => handleDeleteClick(item.id)}
                    >
                      <DeleteIcon />
                    </div>
                  </td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {GetAccess('approvalstatus_create')&&

      <button
        onClick={submitApprovalStatuses}
        className={`mt-4 text-white  text-xs px-2 py-2 rounded-md ${
          loading ? "bg-red-300 cursor-wait" : "bg-baseColor-primary"
        }`}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </button>
}
    </div>
    {showDeleteConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">Are you sure, you want to delete this status?</p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md flex items-center text-textColor-main bg-[#E6F2F2] cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-[8px] text-xs bg-textColor-main cursor-pointer rounded-md text-white"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
</>
  );
};

export default ApprovalProcess;




